/** MultilineTextInput — shared textarea typography. */
export const styles = () => `
app-multiline-field textarea {
  text-align: justify;
}
`;
